import React, { PureComponent } from 'react';
import { Row, Col, Glyphicon } from 'react-bootstrap';
import axios from 'axios';
import { arrayMove } from 'react-sortable-hoc';
import GroupsSortable from './groupsSection/groupsSortable';
import GroupLinksEdit from './groupsSection/groupLinksSection/groupLinksEdit';
import appConstant from '../../../constants/app';

class GroupsSection extends PureComponent {
  state = {
    isLoaderOpened: false,
    groupLinksEdit: false,
    groupSection: {},
    groupLinksSection: [],
  };

  onSortEnd = ({oldIndex, newIndex}) => {
    const {
      onChangeGroupsList,
      items,
    } = this.props;

    this.setState({ isLoaderOpened: true });

    const groupItems = arrayMove(items, oldIndex, newIndex);
    
    axios({
      method: 'post',
      url: `${appConstant.API_URL}/section/positions/update?access_token=${localStorage.getItem('token')}`, 
      data: {
        sections: groupItems.map((item, index) => ({
          id: item.id,
          position: index + 1,
        }))
      },
    })
    .then(res => {
      const sections = res.data;
      onChangeGroupsList(sections.sections);
      this.setState({ isLoaderOpened: false });
    }).catch(err => {
      console.log(err);
    });
  };

  fetchDetail = (id, label) => {
    let url = `${appConstant.API_URL}/section/show/${id}?access_token=${localStorage.getItem('token')}`;
    axios.get(url)
      .then(res => {
        const groupSection = res.data.section;
        this.setState({ 
          groupSection,
          groupLinksSection: groupSection.links,
        });
      }).catch(err => {
        console.log(err);
      });
  }

  onPressDetail = (id, label) => {
    this.fetchDetail(id, label);
    this.setState({
      groupLinksEdit: true,
    });
  }

  onChangeItem = (newValue, key, index) => {
    const {
      groupLinksSection,
    } = this.state;
    
    const newList = groupLinksSection.map(item => item);

    newList[index][key] = newValue;

    this.setState({ groupLinksSection: newList });
  };

  onChangeGroupsLinksList = (list) => {
    this.setState({
      groupLinksSection: list,
    });
  }

  addGroupLinkItem = (groupSectionId) => {
    let position = this.state.groupLinksSection.length > 0 ? this.state.groupLinksSection.reduce((prev, current) => (prev.y > current.y) ? prev : current).pivot.position + 1 : 1
    const newElement = {
      'id': null,
      'label': '',
      'url': '',
      'pivot': {
        'hidden': 0,
        'position': position,
        'section_id': groupSectionId,
      },
    }

    this.setState(prevState => ({
      groupLinksSection: [...prevState.groupLinksSection, newElement]
      })
    );
  };

  deleteItem = (item) => {
    const newList = this.state.groupLinksSection.filter(element => ( element !== item ));

    this.setState({
      groupLinksSection: newList,
    });
  };

  hideItem = (index) => {
    const {
      groupLinksSection,
    } = this.state;

    const newList = groupLinksSection.map(item => item);
    newList[index]['pivot']['hidden'] = newList[index]['pivot']['hidden'] === 0 ? 1: 0;
    this.setState({ groupLinksSection: newList });
  };

  onCancelEdit = (groupSection) => {
    this.props.onClickCancelEdit(groupSection);
    this.setState({groupLinksEdit: false})
  }

  render() {
    const {
      isLoaderOpened,
      groupLinksEdit,
      groupSection,
      groupLinksSection,
    } = this.state;

    const {
      titleSection,
      addGroup,
      showModalHandle,
      items,
      showSectionsList,
    } = this.props;

    return (
      <div>
        {
          !groupLinksEdit ?
          <div>
            <h2 className="main-title group-breadcrumbs">
              <span
                className="back-to-sections"
                onClick={showSectionsList}
              >
                Sections
              </span>
              <Glyphicon glyph="menu-right" />
              {titleSection}
            </h2>
            <div className="group-new-section">
              <h1 className="main-title title-groups-section">{titleSection}</h1>
              <div className="edit-link">
                <span
                  onClick={addGroup}
                  className="new-link-btn"
                >
                  Add Group
                </span>
              </div>
            </div>
            <Row>
              <Col sm={12}>
              {
                isLoaderOpened
                ? <p> Loading... </p>
                : <GroupsSortable
                    items={items}
                    onSortEnd={this.onSortEnd}
                    showModalHandle={showModalHandle}
                    onPressDetail={this.onPressDetail}
                    pressDelay={200}
                  />
              }
              </Col>
            </Row>
          </div>
          :
          <div>
            <h2 className="main-title group-breadcrumbs">
              <span
                className="back-to-sections"
              >
                Sections
              </span>
              <Glyphicon glyph="menu-right" />
              {titleSection}
              <Glyphicon glyph="menu-right" />
              {groupSection.label}
            </h2>
            <Row>
              <Col sm={12}>
              {
                isLoaderOpened
                ? <p> Loading... </p>
                : <GroupLinksEdit
                    groupSection={groupSection}
                    groupLinksSection={groupLinksSection}
                    onChangeItem={this.onChangeItem}
                    onChangeGroupsLinksList={this.onChangeGroupsLinksList}
                    addGroupLinkItem={this.addGroupLinkItem}
                    deleteItem={this.deleteItem}
                    hideItem={this.hideItem}
                    onClickCancelEdit={this.onCancelEdit}
                  />
              }
              </Col>
            </Row>
          </div>
        }
      </div>
    );
  }
}

export default GroupsSection;


// WEBPACK FOOTER //
// ./src/app/screens/sections/groupsSection.js